import { Components } from '@mui/material/styles';

import { buttonSizes, variantStyles } from 'styles/button';

import { colors } from 'theme/colors';
import { JETBRAINS_MONO_REGULAR } from 'theme/fonts';

const button: Components['MuiButton'] = {
  styleOverrides: {
    root: {
      fontFamily: `${JETBRAINS_MONO_REGULAR}, monospace`,
      textTransform: 'unset',
      borderRadius: 0,
      fontWeight: 400,
      transition: 'all 0.2s ease-in-out',
      boxShadow: 'none',
      outline: 'none',
      '&:focus': { outline: 'none' },
      '&:focus-visible': {
        outline: '2px solid',
        outlineColor: colors.button.dark,
        outlineOffset: '2px',
      },
    },

    sizeSmall: buttonSizes.small,
    sizeMedium: buttonSizes.medium,
    sizeLarge: buttonSizes.large,
    contained: {
      '&[data-variant="primary"]': {
        ...variantStyles.primary.default,
        '&:hover': variantStyles.primary.hover,
        '&:active': variantStyles.primary.active,
        '&:focus-visible': variantStyles.primary.focus,
        '&.Mui-disabled': variantStyles.primary.disabled,
      },
      // Secondary Button (Orange/Yellow)
      '&[data-variant="secondary"]': {
        ...variantStyles.secondary.default,
        '&:hover': variantStyles.secondary.hover,
        '&:active': variantStyles.secondary.active,
        '&:focus-visible': variantStyles.secondary.focus,
        '&.Mui-disabled': variantStyles.secondary.disabled,
      },
      // Tertiary Button (Gray)
      '&[data-variant="tertiary"]': {
        ...variantStyles.tertiary.default,
        '&:hover': variantStyles.tertiary.hover,
        '&:active': variantStyles.tertiary.active,
        '&:focus-visible': variantStyles.tertiary.focus,
        '&.Mui-disabled': variantStyles.tertiary.disabled,
      },
      // Danger Button (Red)
      '&[data-variant="danger"]': {
        ...variantStyles.danger.default,
        '&:hover': variantStyles.danger.hover,
        '&:active': variantStyles.danger.active,
        '&:focus-visible': variantStyles.danger.focus,
        '&.Mui-disabled': variantStyles.danger.disabled,
      },
    },
    text: {
      // Link Button (Green text, transparent background)
      '&[data-variant="link"]': {
        ...variantStyles.link.default,
        '&:hover': variantStyles.link.hover,
        '&:active': variantStyles.link.active,
        '&:focus-visible': variantStyles.link.focus,
        '&.Mui-disabled': variantStyles.link.disabled,
      },
      // Text Button (Gray text, transparent background)
      '&[data-variant="text"]': {
        ...variantStyles.text.default,
        '&:hover': variantStyles.text.hover,
        '&:active': variantStyles.text.active,
        '&:focus-visible': variantStyles.text.focus,
        '&.Mui-disabled': variantStyles.text.disabled,
      },
    },
  },
};

export default button;
